/**
 * Public operator identity. Keep web + support desk + legal pages in sync.
 * This is a Utah sole proprietorship — not an LLC or corporation.
 */
export const LEGAL = {
  productName: 'Blind Kings',
  /** Legal name of the individual who operates the Service. */
  operatorName: 'Andrew Giles',
  operatorDba: 'Blind Kings',
  operatorType: 'individual' as const,
  jurisdiction: 'Utah, United States',
  supportEmail: 'support@blindkings.online',
  siteUrl: 'https://blindkings.online',
  /** Last material update to Terms or Privacy. */
  effectiveDate: 'September 3, 2026',
} as const;

export const SUPPORT_MAILTO = `mailto:${LEGAL.supportEmail}`;

export const SITE_URL = LEGAL.siteUrl;
